import { ReactNode } from "react";
import { Header } from "@/components/Header";
import { MobileHeader } from "@/components/MobileHeader";
import { MobileTopBar } from "@/components/MobileTopBar";
import { Footer } from "@/components/Footer";
import { BottomNavigation } from "@/components/BottomNavigation";
import { useScrollDirection } from "@/hooks/useScrollDirection";
import { useIsMobile } from "@/hooks/use-mobile";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

export function PageLayout({ children, className = "" }: PageLayoutProps) {
  const { scrollDirection } = useScrollDirection();
  const isMobile = useIsMobile();
  
  // On mobile, adjust padding based on whether top bar is visible
  const isTopBarHidden = scrollDirection === "down" && isMobile;
  const topPadding = isMobile ? (isTopBarHidden ? "pt-16" : "pt-28") : "pt-0";
  
  return (
    <>
      {/* Mobile Top Bar - scroll responsive, only shows on mobile */}
      <MobileTopBar />
      
      {/* Mobile Header - only shows on mobile */}
      <MobileHeader />
      
      {/* Desktop Header - only shows on desktop */}
      <Header />
      
      {/* Main Content */}
      <main className={`min-h-screen bg-[#F8F5F2] pb-20 md:pb-0 ${topPadding} md:pt-0 ${className}`}>
        {children}
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Mobile Bottom Navigation - only shows on mobile */}
      <BottomNavigation />
    </>
  );
}